import { semanticColors } from '@vake/ui-kit';
import { AnchorSimple, GlobeHemisphereWest, LineSegments, SecurityCamera } from '@phosphor-icons/react';

export const addReportKindSymbol = (kind: string) => {
    if (kind === 'pathfinder') return <LineSegments size={20} color={semanticColors.label.primary} />;
    else if (kind === 'overwatch') return <GlobeHemisphereWest size={20} color={semanticColors.label.primary} />;
    else if (kind === 'clearview') return <SecurityCamera size={20} color={semanticColors.label.primary} />;
    else return <AnchorSimple size={20} color={semanticColors.label.primary} />;
};
